import React, { useState } from "react";
import { useFormik } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as Yup from "yup";
import api from "../../../config/URL";
import { toast } from "react-toastify";
import fetchAllCoursesWithIds from "../../List/CourseList";
import { MultiSelect } from "react-multi-select-component";

const validationSchema = Yup.object({
  courseIds: Yup.array()
    .min(1, "Please select at least one course")
    .required("Please select at least one course"),
});

function CurriculumOutletCopy({ id, onSuccess, handleMenuClose }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);

  const handleClose = () => {
    setOpen(false);
    handleMenuClose();
  };

  const handleOpen = async () => {
    try {
      const data = await fetchAllCoursesWithIds();
      const options = data.map((course) => ({
        label: course.courseNames,
        value: course.id,
      }));
      setCourseOptions(options);
      setOpen(true);
    } catch (err) {
      toast.error("Failed to load courses");
    }
  };

  const formik = useFormik({
    initialValues: {
      courseIds: [],
      curoutIds: [id],
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await api.post("/reusableCurriculumCodes", values);
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          onSuccess();
          handleClose();
        } else {
          toast.error(response.data.message);
        }
      } catch (err) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <p onClick={handleOpen} className="text-start mb-0 menuitem-style">
        Curriculum Outlet Copy
      </p>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            height: "400px",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle>Curriculum Outlet Copy</DialogTitle>
        <form
          onSubmit={formik.handleSubmit}
          style={{ display: "flex", flexDirection: "column", flex: 1 }}
        >
          <DialogContent style={{ flex: 1, overflowY: "auto" }}>
            <div className="mb-4">
              <label className="form-label mb-2">
                Courses<span className="text-danger">*</span>
              </label>
              <MultiSelect
                options={courseOptions}
                value={selectedCourses}
                onChange={(selected) => {
                  setSelectedCourses(selected);
                  formik.setFieldValue(
                    "courseIds",
                    selected.map((option) => option.value)
                  );
                }}
                labelledBy="Select Courses"
                className={`form-multi-select ${
                  formik.touched.courseIds && formik.errors.courseIds
                    ? "is-invalid"
                    : ""
                }`}
                onBlur={() => formik.setFieldTouched("courseIds", true)}
              />
            </div>
            {formik.touched.courseIds && formik.errors.courseIds && (
              <div className="text-danger mt-1">{formik.errors.courseIds}</div>
            )}
          </DialogContent>

          <DialogActions
            style={{
              borderTop: "1px solid #eee",
              padding: "16px",
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-sm btn-success"
              disabled={loading}
            >
              {loading && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
              )}
              Submit
            </button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default CurriculumOutletCopy;
